import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'split-report-message',
  templateUrl: './report-message.component.html',
  styleUrls: ['./report-message.component.scss'],
})
export class ReportMessageComponent {

  @Input() value: string | number = ''
  @Input() label: string = ''
  @Input() bgColor: string = ''
  @Input() borderColor: string = ''
  @Input() disableBorder: boolean = false;
  @Input() width: string = ''

  @Input() tooltipMessage: string | TemplateRef<any> = ''
}
